var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 181,
    height: 142,
    viewBox: "0 0 181 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#000",
    strokeWidth: 4,
    d: "m40.19 73.54 1.85.47.56-1.82c2.13-6.95 8.18-13.3 17.05-17.93 8.85-4.62 20.32-7.44 32.9-7.44 13.08 0 24.95 3.05 33.93 8 9 4.95 14.88 11.7 16.46 19l.58 2.68 2.37-1.36a19.67 19.67 0 0 1 9.87-2.67c11.9 0 21.93 10.95 21.93 24.99s-10.04 25-21.93 25c-4.77 0-9.2-1.74-12.82-4.73l-2.1-1.72-1.03 2.5c-3.84 9.35-13.6 16.1-25.13 16.1a27.82 27.82 0 0 1-19.45-7.74l-1.81-1.76-1.3 2.17C87.59 134.85 78.99 140 69.08 140c-11.95 0-21.97-7.47-25.28-17.63l-.6-1.85-1.87.55c-3.04.9-6.31 1.38-9.73 1.38-16.65 0-29.6-11.47-29.6-24.99 0-13.52 12.95-25 29.6-25 3 0 5.88.38 8.59 1.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#000",
    strokeWidth: 4,
    d: "m149.41 19.87.56 1.82 1.85-.47c1.9-.49 3.94-.75 6.04-.75 11.77 0 20.76 8.09 20.76 17.44 0 9.34-8.99 17.43-20.76 17.43-2.4 0-4.7-.34-6.85-.97l-1.86-.55-.6 1.85c-2.3 7.07-9.3 12.3-17.67 12.3-6.95 0-12.96-3.6-16.11-8.88l-1.3-2.17-1.81 1.76a19.47 19.47 0 0 1-13.62 5.41c-8.1 0-14.9-4.72-17.58-11.24l-1.03-2.5-2.1 1.72a13.9 13.9 0 0 1-8.87 3.27c-8.2 0-15.23-7.57-15.23-17.43 0-9.87 7.03-17.44 15.23-17.44 2.45 0 4.76.66 6.82 1.85l2.38 1.36.58-2.67c1.1-5.06 5.17-9.8 11.58-13.33C96.18 4.18 104.64 2 113.97 2c8.98 0 17.15 2.01 23.44 5.3 6.3 3.3 10.52 7.76 12 12.57Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 89.84,
    x2: 89.84,
    y1: 44.82,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 115.92,
    x2: 115.92,
    y1: 0,
    y2: 69.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.def74dce9b57efe7b3ae1e87bd472c6b.svg";
export { ForwardRef as ReactComponent };